import { RoleDto, RoleTypeEnum } from "@app/api";
import { CerNavigationNode } from "@app/app.module-generated";

export class CerAppNavigationNodesUserLoader {

  constructor(private rolesActive: RoleDto[]) {
  }

  public load(navigationAll: CerNavigationNode[]): CerNavigationNode[] {
    var nodes: CerNavigationNode[] = Object.assign([], navigationAll);
    CerAppNavigationNodesUserLoader.setupNavigationNode(nodes, this.rolesActive);
    return nodes;
  }

  private static setupNavigationItem(node: CerNavigationNode, rolesActive: RoleDto[]): boolean {
    var allow: boolean = true;
    if (node) {
      if (node.roles) {

        var allow: boolean = true;
        if (node.roles?.length > 0 && !CerAppNavigationNodesUserLoader.userRolesCheck(node.roles, rolesActive, true)) {
          allow = false;
        }
        else if (node.rolesNot?.length > 0 && !CerAppNavigationNodesUserLoader.userRolesCheck(node.rolesNot, rolesActive, false)) {
          allow = false;
        }
      }
      if (allow) {
        allow = (node.url?.length > 0 ||
          (node.childNodes?.length > 0 && CerAppNavigationNodesUserLoader.setupNavigationNode(node.childNodes, rolesActive)));
      }
    }
    return allow;
  }

  private static setupNavigationNode(nodes: CerNavigationNode[], rolesActive: RoleDto[]): boolean {
    var hasNodes = false;
    for (var i = nodes.length - 1; i >= 0; i--) {
      const item = nodes[i];
      if (CerAppNavigationNodesUserLoader.setupNavigationItem(item, rolesActive)) {
        hasNodes = true;
      }
      else {
        nodes.splice(i, 1);
      }
    }
    return hasNodes;
  }

  private static userRolesCheck(requiredRoles: RoleTypeEnum[], userRoles: RoleDto[], defaultOk: boolean = false): boolean {
    var ok: boolean = defaultOk;

    if (requiredRoles && requiredRoles.length > 0) {
      ok = false;
      if (userRoles && userRoles.length > 0) {
        requiredRoles.forEach(r =>
          userRoles.forEach(ur => {
            if (ur.roleType == r) {
              ok = true;
            }
          }));
      }
    }
    return ok;
  }
}
